"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartSimulation = void 0;
var _1 = require(".");
var data_1 = require("./data");
var enums_1 = require("./enums");
var lib_1 = require("./lib/lib");
var math_1 = require("./lib/math");
var time_1 = require("./lib/time");
var offlineIncome_1 = require("./offlineIncome");
var rewardedPopup_1 = require("./rewardedPopup");
var shop_1 = require("./shop");
var logTimes = [
    5 * 60,
    15 * 60,
    30 * 60,
    1 * 60 * 60,
    2 * 60 * 60,
    3 * 60 * 60, //1h
];
var upgradeBuyOrder = __spreadArray(__spreadArray([enums_1.ITEM.BricksPerClick, enums_1.ITEM.MoneyPerBrick], data_1.Builders, true), [enums_1.ITEM.HouseSize, enums_1.ITEM.Bank, enums_1.ITEM.Banker], false); // upgrades in which way they are more valuable to buy
var timeToRun = logTimes[logTimes.length - 1];
var averageCPS = 5; // initially I wanted to set this to loer, 3, because I thought people will click more rare, but it turns out they click pretty active
var nextBreakTime = function () { return Math.floor(10 * 60 + Math.random() * 20 * 60); }; // break approximately every 30 min
var nextBoostTime = function () { return Math.floor(2 * 60 + Math.random() * 3 * 60); }; // booster approximately every 5 min
var tick = 0; // every tick is a second in real life
var nextBreak = nextBreakTime();
var nextBoost = nextBoostTime();
var stopBoost = 0;
var housesBuilt = 0;
var boostersUsed = 0;
var secondsOnBooster = 0;
var breaksTaken = 0;
var totalOfflineIncome = 0;
var StartSimulation = function () {
    console.time("Simulation duration");
    while (tick <= timeToRun) {
        if (logTimes.includes(tick)) {
            LogData(tick);
        }
        for (var i = 0; i < averageCPS; i++) {
            (0, lib_1.AddBricks)((0, lib_1.CalcBricksPerClick)());
        }
        if (data_1.GameData.placedBricks >= data_1.HouseData.totalBricks) {
            (0, _1.OnHouseRewardCollectClick)();
            housesBuilt++;
        }
        if (Math.random() < 1) {
            // don't check shop every second
            var shuffled = upgradeBuyOrder
                .map(function (value) { return ({ value: value, sort: Math.random() }); })
                .sort(function (a, b) { return a.sort - b.sort; })
                .map(function (_a) {
                var value = _a.value;
                return value;
            });
            var isShuffle = Math.random() < 0.333;
            var itemList = isShuffle ? shuffled : upgradeBuyOrder;
            for (var j = 0; j < 2; j++) {
                // try buying multiple times
                for (var i = 0; i < itemList.length; i++) {
                    if ((0, shop_1.CanBuyItem)(itemList[i])) {
                        var moneyBefore = data_1.GameData.money;
                        (0, shop_1.OnItemBuyClick)(itemList[i]);
                        console.log("Time ".concat((0, time_1.msToHHMM)(tick * 1000), " BUY (").concat(isShuffle ? "shuffled" : "smart", ") Item: ").concat(itemList[i], " Money before: ").concat((0, math_1.FormatNumber)(moneyBefore), ", Money now: ").concat((0, math_1.FormatNumber)(data_1.GameData.money)));
                        break;
                    }
                }
            }
        }
        data_1.Builders.forEach(function (item) {
            if (tick % data_1.Items[item].intervalSeconds === 0) {
                if (data_1.GameData.itemLevel[item]) {
                    (0, lib_1.AddBricks)(data_1.GameData.itemLevel[item]);
                }
            }
        });
        if (tick == nextBreak) {
            var moneyBeforeBreak = data_1.GameData.money;
            var breakDurationHouse = Math.floor(2 + Math.random() * 12);
            var offlineIncome = (0, offlineIncome_1.CheckOfflineIncome)(Math.floor(breakDurationHouse * 60 * 60 * 1000)); // average break 2-14 hours
            data_1.GameData.money += offlineIncome;
            totalOfflineIncome += offlineIncome;
            console.log("Time ".concat((0, time_1.msToHHMM)(tick * 1000), " BREAK, Duration ").concat(breakDurationHouse, "h, Offline income ").concat((0, math_1.FormatNumber)(offlineIncome), ", Money before: ").concat((0, math_1.FormatNumber)(moneyBeforeBreak), ", Money now: ").concat((0, math_1.FormatNumber)(data_1.GameData.money)));
            nextBreak = tick + nextBreakTime(); // break approximately every 30 min
            breaksTaken++;
        }
        if (tick == nextBoost) {
            nextBoost = tick + nextBoostTime() + rewardedPopup_1.boosterDurationSeconds;
            (0, rewardedPopup_1.SetPremiumIsActive)(true);
            stopBoost = tick + rewardedPopup_1.boosterDurationSeconds;
            boostersUsed++;
        }
        if (rewardedPopup_1.PremiumIsActive) {
            secondsOnBooster++;
        }
        if (tick == stopBoost) {
            (0, rewardedPopup_1.SetPremiumIsActive)(false);
        }
        tick++;
    }
    console.log("Houses built ".concat(housesBuilt));
    console.log("Boosters used ".concat(boostersUsed));
    console.log("Seconds on booster ".concat(secondsOnBooster));
    console.log("Breaks taken ".concat(breaksTaken, ", total offline income ").concat((0, math_1.FormatNumber)(totalOfflineIncome)));
    console.log("House bricks ".concat(data_1.HouseData.totalBricks));
    console.log("Average bricks per second from click ".concat((0, lib_1.CalcBricksPerClick)() * averageCPS));
    console.log("Average bricks per second builders ".concat((0, lib_1.CalcBricksPerSecondFromBuilders)()));
    console.log("Current time to complete house ".concat(data_1.HouseData.totalBricks / ((0, lib_1.CalcBricksPerClick)() * averageCPS + (0, lib_1.CalcBricksPerSecondFromBuilders)())));
    console.log("Offline income per hour ".concat((0, math_1.FormatNumber)(3600 * ((0, lib_1.CalcIncomePerSecond)() / offlineIncome_1.offlineIncomeDivider))));
    console.timeEnd("Simulation duration");
};
exports.StartSimulation = StartSimulation;
var LogData = function (seconds) {
    console.log("Time ".concat((0, time_1.msToHHMM)(seconds * 1000), "\nUpgrades:\n Money per brick: ").concat(data_1.GameData.itemLevel.moneyPerBrick, "\n Bricks per click: ").concat(data_1.GameData.itemLevel.bricksPerClick, "\n House size: ").concat(data_1.GameData.itemLevel.houseSize, "\n Bank: ").concat(data_1.GameData.itemLevel.bank, "\n Banker: ").concat(data_1.GameData.itemLevel.banker, "\nBuilders:\n ").concat(data_1.Builders.map(function (i) { return "".concat(i, " ").concat(data_1.GameData.itemLevel[i]); }).join("\n "), "\n    "));
};
